import { render, staticRenderFns } from "./NsTextField.vue?vue&type=template&id=a2dfaab6&scoped=true&"
import script from "./NsTextField.vue?vue&type=script&lang=js&"
export * from "./NsTextField.vue?vue&type=script&lang=js&"
import style0 from "./NsTextField.vue?vue&type=style&index=0&id=a2dfaab6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2dfaab6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/gitlab-runner-data/builds/ns-am/product/apps/catalog/components/Button.vue').default})
